import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import OpinionsFeaturesStories from "@pages/Home/OpinionFeatures/OpinionFeaturesStories";
import Card from "@particles/card/Card";
import { sectionNavigationItems } from "@util/constant";
import { cn } from "@util/helpers";

export type OpinionFeaturesProps = {
  /** Additionl styling for the component */
  className?: string;
  /** The list of the article card props */
  cardProps: ComponentProps<typeof Card>[];
};

const section = sectionNavigationItems["opinion-features"];

/**
 * Renders the Home - Opinion Features section with a title and a list of articles.
 * https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=1312-2190&t=g7P8QlYHW3Ymfii6-4
 */
const OpinionFeatures = ({
  className,
  cardProps,
}: OpinionFeaturesProps): React.ReactElement => {
  return (
    <section
      className={className}
      data-testid="homepage-opinion-features-stories-component"
    >
      <BlockTitle
        link={section?.link}
        text={section?.label?.toUpperCase() ?? ""}
      />

      <div
        className={cn(
          "stories lg:grid lg:grid-flow-col lg:grid-cols-3 lg:grid-rows-1"
        )}
      >
        {cardProps.map((card, index) => {
          return (
            <OpinionsFeaturesStories
              cardProps={card}
              index={index}
              key={card.id}
            />
          );
        })}
      </div>
    </section>
  );
};

export default OpinionFeatures;
